import styled from 'styled-components'

export const FormItemContainer = styled.div`
  margin-bottom: 0.25rem;

  .ant-form-item-label {
    padding: 0;
  }

  transition-duration: 0.1s !important;

  max-width: 100%;
  overflow: hidden;
`
